export const appName = `gif-selection-quiz`;
